const defLocation = () => ({
	lat: '',
	lng: '',
	city: '',
	name: '',
	desc: '',
	adcode: '',
	address: '',
	citycode: '',
	district: '',
	province: '',
	country: '',
	custom: false,
	error: false,
});

export const useLocationStore = defineStore('locationStore', () => {
	const location = ref<ReturnType<typeof defLocation>>(
		uni.getStorageSync(LOCATION_INFO) || defLocation(),
	);

	const regeoLocation = async (lat?, lng?, custom = false) => {
		if (lat && lng) {
			location.value = defLocation();
			merge(location.value, { lat, lng });
			try {
				const info = await request.get(port.REGEO_REGEO, { lat, lng });
				// const info = await getRegeocode(lat, lng);
				merge(location.value, info, { custom });
				uni.setStorageSync(LOCATION_INFO, location.value);
			} finally {
				return location.value;
			}
		} else {
			location.value.error = true;
			return location.value;
		}
	};

	const getLocation = async (init = false): Promise<typeof location.value> => {
		return new Promise(async (resolve) => {
			const { lat, lng } = location.value;
			if (lat && lng && !init) {
				resolve(location.value);
				return;
			}

			// #ifdef APP
			if (systemInfo().plat == 'android') {
				const result = await requestAndroidPermission('android.permission.ACCESS_FINE_LOCATION');
				if (result != 1) {
					resolve(await regeoLocation());
					return;
				}
			} else if (systemInfo().plat == 'ios') {
				const result = await judgeIosPermission('location');
				if (result != 1) {
					resolve(await regeoLocation());
					return;
				}
			}
			// #endif

			// #ifndef H5
			uni.getLocation({
				type: 'gcj02',
				isHighAccuracy: true,
				async success({ latitude, longitude }) {
					resolve(await regeoLocation(latitude, longitude));
				},
				async fail() {
					resolve(await regeoLocation());
				},
			});
			// #endif

			// #ifdef H5
			navigator.geolocation.getCurrentPosition(
				async (pos) => {
					const { latitude: lat, longitude: lng } = pos.coords;
					resolve(await regeoLocation(lat, lng));
				},
				async () => resolve(await regeoLocation()),
			);
			// #endif
		});
	};

	return {
		location,
		getLocation,
		regeoLocation,
	};
});
